import { Fragment, ReactNode, useState } from "react";

// The view stack holds a step for a second after its route stops matching.
// Coming back to it in that second would pick up the same instance, with the
// state of the earlier visit, so each new match mounts it afresh. Keyed on the
// match rather than on the step being on screen: a step whose route is a
// prefix of another's, like select-visit under its confirm screen, stays
// matched underneath and keeps its state, as it always has.
export function StepEntry({
  matched,
  children,
}: {
  matched: boolean;
  children: ReactNode;
}) {
  const [entry, setEntry] = useState(0);
  const [wasMatched, setWasMatched] = useState(matched);
  if (matched !== wasMatched) {
    setWasMatched(matched);
    if (matched) {
      setEntry(entry + 1);
    }
  }

  return <Fragment key={entry}>{children}</Fragment>;
}
